type LogoProps = {
  color?: "white" | "black";
  size?: "small" | "medium" | "large";
};

const Logo = ({ color = "white", size = "medium" }: LogoProps) => {
  const textColor = color === "black" ? "text-black dark:text-white" : "text-white dark:text-black";
  let textSize = "text-base md:text-lg";
  if (size === "small") textSize = "text-sm md:text-base";
  if (size === "large") textSize = "text-2xl md:text-3xl";
  return (
    <span
      className={`tpr-font ${textColor} ${textSize} flex justify-center truncate antialiased font-stretch-semi-condensed`}
    >
      THE PRACTICE ROOMS
    </span>
  );
};

export default Logo;
